module.exports = __webpack_public_path__ + "media/smart_tutorial.d388ee47.mp4";